<template>
  <div
    id="kompack-onboarding-container"
    class="h-screen bg-white"
  >
    <iframe
      frameborder="1"
      height="100%"
      width="100%"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/onboarding/kompack`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
import { updateOnboardingKompackStatus, updateProfileKompackOnboarding } from '@/@core/utils/kompack/checker'

export default {
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      key: null,
      userId: null,
      password: null,
      pin: null,
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type,
          data,
          profile,
        } = event.data

        if (type === 'ONBOARDING_COMPLETED') {
          updateOnboardingKompackStatus()
          if (profile) {
            this.$store.dispatch('dashboard/getProfile')
            updateProfileKompackOnboarding({
              brand_name: profile.partner_business_name,
              pic_phone: profile.partner_no_hp_business,
              business_location: profile.address_partner_business,
            })
          }
          const popup = this.$swal({
            title: '✅ Data berhasil disimpan!',
            html: '<p class="my-2">Selamat datang di Kompack — akunmu sudah siap digunakan. Yuk, mulai kelola order, stok, dan pengiriman dari satu tempat!</p>',
            icon: 'success',
            showConfirmButton: false,
          })
          setTimeout(() => {
            popup.close()
            this.$router.push('/gudangku')
          }, 3000)
        }

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }
      }
    },
  },
}
</script>
